// Tiny SVG line chart used in dashboard stat cards. Pure presentational —
// the data comes from props. Hand-drawn (no chart lib) per the design.

interface Props {
  points: number[];
  color?: string;
  width?: number;
  height?: number;
  fill?: boolean;
}

export const Sparkline = ({
  points,
  color = '#6366F1',
  width = 180,
  height = 28,
  fill = true,
}: Props) => {
  if (points.length < 2) return null;
  const max = Math.max(...points);
  const min = Math.min(...points);
  const range = max - min || 1;
  const step = width / (points.length - 1);
  const path = points
    .map((p, i) => {
      const x = (i * step).toFixed(1);
      const y = (height - ((p - min) / range) * (height - 4) - 2).toFixed(1);
      return `${i === 0 ? 'M' : 'L'}${x} ${y}`;
    })
    .join(' ');
  const area = `${path} L${width} ${height} L0 ${height} Z`;
  const lastY = height - ((points[points.length - 1] - min) / range) * (height - 4) - 2;
  return (
    <svg width={width} height={height} style={{ display: 'block', overflow: 'visible' }}>
      {fill && <path d={area} fill={color} opacity={0.08} />}
      <path d={path} stroke={color} strokeWidth={1.5} fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx={width} cy={lastY} r={2.5} fill={color} />
    </svg>
  );
};
